import type { UserProfile } from "./schemas"

/**
 * Rol/scope-bazlı erişim yordamları — nav gating + route guard TEK kaynaktan
 * (ADR #029). Org-hiyerarşi: admin (root) her şeyi görür; org-scoped login
 * (bayi/partner) yalnız kendi subtree'sine SCOPE'LU ekranları görür.
 *
 * Org-scoped'a GÖRÜNÜR (backend subtree filtreler, 200): Genel Bakış (overview/summary),
 * Cihazlar, Sahalar (sites), Alarmlar, Organizasyonlar, Destek; 2026-08-04'ten itibaren
 * Partnerler + Bayiler (ADR #034 ile `SuperAdmin/orgs` projeksiyonuna çevrildiler) ve
 * aynı gün Kullanıcılar + Bildirim Kuralları (backend'de ResolveOrgScope'a geçtiler).
 *
 * Org-scoped'a GİZLİ kalanlar: Toplu Güncelleme + SSH Tüneller (e-posta allowlist'i) ve
 * Push Bildirimleri (son kullanıcının telefonuna doğrudan bildirim gönderiyor, hedefleme
 * listesi tüm kullanıcı/sahaları gösteriyor → AdminOnly).
 *
 * KURAL: bir ekranın kapısı ancak backend o uçta gerçekten scope uyguluyorsa kaldırılır.
 * Kullanıcılar sayfasındaki partner/bayi ATAMASI hâlâ AdminOnly — o aksiyon menü kapısıyla
 * değil, `EndUsersTable` içinde ayrıca gizlenir.
 */

/**
 * Org-scoped (bayi/partner) login mi? `orgId` (veya legacy `partnerId`) doluysa evet.
 * Admin (Administrator, org claim'i yok) → false.
 */
export function isOrgScoped(user: UserProfile | null | undefined): boolean {
  return Boolean(user?.orgId ?? user?.partnerId)
}

/**
 * Yalnız admin (root scope) erişebilen alan mı? Org-scoped kullanıcı göremez/giremez.
 * Nav `canAccess` ve ilgili route `beforeLoad` AYNI predicate'i kullanır (drift olmaz).
 */
export function canAccessAdminArea(user: UserProfile | null | undefined): boolean {
  return !isOrgScoped(user)
}
